import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const navItems = [
  { path: '/', icon: 'FiHome' },
  { path: '/demo', icon: 'FiCpu' },
  { path: '/builder', icon: 'FiPlusSquare' },
  { path: '/rooms', icon: 'FiRadio' },
  { path: '/settings', icon: 'FiSliders' },
];

export default function MobileNav() {
  return (
    <div className="md:hidden fixed bottom-28 left-4 right-4 bg-vinyl-800/90 backdrop-blur-lg border border-vinyl-700 rounded-2xl p-2 flex justify-around items-center z-40 shadow-2xl">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `p-3 rounded-xl transition-all duration-300 ${
              isActive
                ? 'bg-gradient-to-br from-plasma/20 to-aqua/20 text-aqua glow-aqua'
                : 'text-gray-400 hover:text-white'
            }`
          }
        >
          <SafeIcon icon={item.icon} className="text-xl" />
        </NavLink>
      ))}
    </div>
  );
}